import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, TextField, Grid, DialogActions, Button, FormControlLabel, Checkbox, Divider, Typography, DialogTitle, } from "@material-ui/core";
import { SelectListField } from "../../../common/SelectListField";
import { CommsTypesService } from "../../../../services/business/CommsTypesService";
import { useFormState } from "../../../../hooks/useFormState";
import { useDispatch } from "react-redux";
import { submitComms } from "../../../../redux/actions";
const MULTILINE_ROW_HEIGHT = 8;
const CHARACTER_LIMIT = 5000;
const useStyles = makeStyles({
    paper: {
        width: "600px",
    },
    titleStyle: {
        "& h2": {
            fontWeight: "600",
            color: "#949494",
            fontSize: "1.2em",
        },
    },
    contentStyle: {
        color: "#515151",
    },
    helperText: {
        fontSize: "1em",
    },
});
export const NewCaseCommsDialog = ({ isDialogOpen, onDialogClose, caseId, isWhistleblower, hasEmailAddress, }) => {
    var _a, _b, _c, _d;
    const dialogStyles = useStyles();
    const dispatch = useDispatch();
    const { state, formProps, formPropsFileInput, formPropsCheckbox, triggerSubmit, triggerReset } = useFormState({
        commsBody: "",
        commsSubject: "",
        commsType: "",
    }, [
        "commsBody",
        "commsSubject",
        "commsType",
        ["isConfirmed", ({ val }) => (val ? "" : "Please confirm")],
    ], ({ state }) => {
        dispatch(submitComms(caseId, state.values));
        onDialogClose();
        triggerReset();
    });
    const typeService = new CommsTypesService(isWhistleblower);
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "New Communication"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, { "data-test": "new-communication-popup" },
            !hasEmailAddress && (React.createElement(Typography, null, "There is no email address recorded, please enter one in the Contact Details section to proceed.")),
            hasEmailAddress && (React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("commsType"), { label: "Communication Type", dataTest: "communication-type-contact-citizen", service: typeService }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("commsSubject"), { label: "Subject", "data-test": "subject-field-contact-citizen", fullWidth: true, inputProps: { maxLength: 200 } }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("commsBody"), { label: "Body", "data-test": "body-field-contact-citizen", fullWidth: true, multiline: true, inputProps: {
                                maxlength: CHARACTER_LIMIT,
                            }, rows: MULTILINE_ROW_HEIGHT, helperText: `${state.values.commsBody.length}/${CHARACTER_LIMIT}`, FormHelperTextProps: {
                                className: dialogStyles.helperText,
                            } }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formPropsFileInput("file"), { id: "text-button-file", type: "file", style: { display: "none" } })),
                        React.createElement("label", { htmlFor: "text-button-file" },
                            React.createElement(Button, { variant: "contained", color: "primary", component: "span" }, "Select File (optional)..."), (_b = (_a = state.values) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 :
                            _b.name)),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(Divider, null),
                        React.createElement("br", null),
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, Object.assign({}, formPropsCheckbox("isConfirmed"), { color: "default" })), label: "I understand that this communication is directed at, and visible to, the complainant:", "data-test": "understand-checkbox", labelPlacement: "start", style: { color: ((_c = state.fieldMeta.isConfirmed) === null || _c === void 0 ? void 0 : _c.error) ? "red" : "inherit" } })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => {
                    onDialogClose();
                    triggerReset();
                }, "data-test": "new-communication-cancel", color: "primary" }, "Close"),
            hasEmailAddress && (React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "new-communication-confirm", color: "primary" },
                "Create Communication ", (_d = state.fieldMeta.isConfirmed) === null || _d === void 0 ? void 0 :
                _d.error)))));
};
